import axios from "axios";
import qs from "qs";
import router from '../router'
import store from '../store'
import {Message, Loading} from 'element-ui';
import setLog from './log.js';

var autoLogTime = null
let baseURL
// 判断开发环境（一般用于本地代理）
if (process.env.NODE_ENV === 'development') {      // 开发环境
  baseURL = window.APIURL.devUrlApi
} else {                                           // 生产环境
  baseURL = window.APIURL.prodUrlApi
}

/****** 创建axios实例 ******/
const service = axios.create({
  withCredentials: true,
  baseURL: baseURL,  // api的base_url
  timeout: 60000  // 请求超时时间
});


let loading;        //定义loading变量
function startLoading() {    //使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0.3)'
  })
}

function endLoading() {    //使用Element loading-close 方法
  loading.close()
}

let needLoadingRequestCount = 0

export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}


/****** request拦截器==>对请求参数做处理 ******/
service.interceptors.request.use(config => {

  //打开预加载
  if (config.showLoading) {
    showFullScreenLoading();
  }
  //外部应用接口vdnId用传参进来的值
  if(config.newVdnId){
    config.url = config.url + '?vdnId=' + config.data.vdnId
    if(config.type !== 'body'){
      delete config.data.vdnId
    }
  }

  config.type === 'body' ? config.data = {...config.data} : config.method === 'post' ? config.data = qs.stringify({...config.data}) : config.params = {...config.params};
  config.headers['Content-Type'] = config.type === 'body' ? 'application/json' : 'application/x-www-form-urlencoded;charset=UTF-8';
  config.headers['Authorization'] = JSON.parse(LocalStorage.getItem('obj')) ? JSON.parse(LocalStorage.getItem('obj')).authToken : '';
  config.headers['x-requested-with'] = 'XMLHttpRequest';
  //params没有vdnId的话统一添加
  if(LocalStorage.getItem('obj') && JSON.parse(LocalStorage.getItem('obj')).vdnId && (!config.params || !config.params.vdnId) && !config.newVdnId){
    config.url = config.url + '?vdnId=' + JSON.parse(LocalStorage.getItem('obj')).vdnId
  }
  return config;
}, error => {  //请求错误处理
  Message({
    message: error,
    type: 'error'
  });
  endLoading()
  Promise.reject(error)
});


/****** respone拦截器==>对响应做处理 ******/
service.interceptors.response.use(
  response => {  //成功请求到数据
    //关闭预加载
    if (response.config.showLoading) {
      tryHideFullScreenLoading();
    }
    if (response.status === 200) {
      //排除不需要提示的情况
      if(response.data.retCode !== 1 && response.data.retCode !== 100 && response.data.retCode !== 105 && response.data.retCode !== 3){
        if(response.data.retCode === 114 || response.data.retCode === 106){

          //被踢下线或token过期，只显示最后一次错误提示
          Message.closeAll()
        }
        Message({
          message: response.data.retMsg,
          type: 'error'
        });
      }
      //下列状态退回登录页面
      if (response.data.retCode === 105 || response.data.retCode === 106 || response.data.retCode === 109 || response.data.retCode === 102 || response.data.retCode === 5 || response.data.retCode === 114) {
        console.log(response.data.retMsg)
        cloudClearStorage()
        setTimeout(function() {
          let vdn = ''
          if (LocalStorage.getItem("obj")) {
            vdn = JSON.parse(LocalStorage.getItem("obj")).vdnId
            LocalStorage.removeItem('obj');
            LocalStorage.removeItem('getPublicKey');
          }
          let Lang = '';
          if(window.location.href.indexOf('?') > -1){
            Lang = window.location.href.split('?')[1];
          }
          console.log('接口状态码' + response.data.retCode + '触发退出......')
          if(Lang && Lang.indexOf('vdnId') > -1){
            router.push("/?" + Lang);
          }else if(vdn){
            router.push('/?vdnId=' + vdn + (Lang?'&' + Lang:''));
          }else{
            router.push('/' + (Lang?'?' + Lang:''));
          }
          window.location.reload()
        })
      }

      return response.data;
    }else {
      Message({
        message: response.statusText?response.statusText:response.data.retMsg,
        type: 'warning'
      });

      pjLog(response, 'warn') //拼接日志

    }
  },
  error => {  //响应错误处理
    console.log('error');
    console.log(error);
    let stack = new Error(error).stack;
    if (stack.indexOf('403') > -1) {
      console.log('用户无权访问接口');
      Message({
        message: '用户无权访问接口',
        type: 'error'
      });
    } else {
      Message({
        message: '网络异常，请稍后再试！',
        type: 'error'
      });
    }

    pjLog(error.response, 'error') //拼接日志

    try {
      //关闭预加载
      if (error.config.showLoading) {
        tryHideFullScreenLoading();
      }
      return Promise.reject(error)
    } catch (err) {
      tryHideFullScreenLoading();
    }

  }
);

// 云版本线上客服-全媒体被抢登的时候需要清除token相关缓存
async function cloudClearStorage() {
  let viewData = ['HisSession', 'HistorySession', 'AgentView', 'MsgManage', 'AgentStateList', 'SessionMonitor']
  viewData.map((item, index) => {
    if ($('iframe[name="'+item+'"]')[0]) {
      $('iframe[name="'+item+'"]')[0].contentWindow.postMessage({message: 'clearstorageobj'}, '*')
    }
  })
}

function getDateInfo(){
  let date = new Date();
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? '0' + m : m;
  var d = date.getDate();
  d = d < 10 ? '0' + d : d;
  var h = date.getHours();
  h = h < 10 ? '0' + h : h;
  var m = date.getMinutes();
  m = m < 10 ? '0' + m : m;
  var s = date.getSeconds();
  s = s < 10 ? '0' + s : s;

  return y + '-' + m + '-' + d + ' ' + h + ':' + m + ':' + s
}

//拼接缓存里的日志一起发送
function pjLog(response, logLevel){
  //当次的错误信息
  if(response){
    let logData = [{
      logModel: response.config.url,
      logLevel: logLevel,
      logCnt: response.data.retMsg,
      logTime: getDateInfo()
    }]
    if(LocalStorage.getItem('logData')){ //缓存有其他操作信息，合并后发送给后端
      let arr = JSON.parse(LocalStorage.getItem('logData'))
      arr = arr.concat(logData)
      logData = arr
    }
    if(LocalStorage.getItem('obj')){
      let setData = {
        vdnId: JSON.parse(LocalStorage.getItem('obj')).vdnId,
        logData: logData
      }
      setLog(baseURL, setData)
    }
  }
}

function autoLog(){
  autoLogTime = setTimeout(()=>{
    //每1分钟，把存在缓存的日志发送给后端
    if(LocalStorage.getItem('obj')){
      if(LocalStorage.getItem('logData')){
        let setData = {
          vdnId: JSON.parse(LocalStorage.getItem('obj')).vdnId,
          logData: JSON.parse(LocalStorage.getItem('logData'))
        }
        setLog(baseURL, setData)
      }
      clearTimeout(autoLogTime)
      autoLogTime = null
      autoLog()
    }else{
      clearTimeout(autoLogTime)
      autoLogTime = null
    }
  }, 60000)
}
autoLog()

export default service;


// WEBPACK FOOTER //
// ./src/http/request.js